import React, { useState } from "react";
import PropTypes from "prop-types";

const CopyButton = ({ value, onCopy, className, ...props }) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopySuccess(true);
      if (onCopy) onCopy(value);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = value;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopySuccess(true);
      if (onCopy) onCopy(value);
      setTimeout(() => setCopySuccess(false), 2000);
    }
  };

  return (
    <button
      type="button"
      aria-label="Copy to clipboard"
      className={`btn btn-secondary btn-medium ${className}`}
      onClick={handleCopy}
      title={copySuccess ? "Copied!" : "Copy to clipboard"}
    >
      {copySuccess ? (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="currentColor"
          style={{ margin: 0 }}
        >
          <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
        </svg>
      ) : (
        <svg
          width="16"
          height="16"
          viewBox="0 0 352.804 352.804"
          fill="currentColor"
          style={{ margin: 0 }}
        >
          <path d="M318.54,57.282h-47.652V15c0-8.284-6.716-15-15-15H34.264c-8.284,0-15,6.716-15,15v265.522c0,8.284,6.716,15,15,15h47.651 v42.281c0,8.284,6.716,15,15,15H318.54c8.284,0,15-6.716,15-15V72.282C333.54,63.998,326.824,57.282,318.54,57.282z M49.264,265.522V30h191.623v27.282H96.916c-8.284,0-15,6.716-15,15v193.24H49.264z M303.54,322.804H111.916V87.282H303.54V322.804 z" />
        </svg>
      )}
    </button>
  );
};

CopyButton.propTypes = {
  value: PropTypes.string.isRequired,
  onCopy: PropTypes.func,
  className: PropTypes.string,
};

CopyButton.defaultProps = {
  onCopy: null,
  className: "",
};

export default CopyButton;
